import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
// import { ImportOrderComponent } from './orders/container/import-order/import-order.component';
import { auth2Guard } from './_guard/auth2.guard';
import { authGuard } from './_guard/auth.guard';
import { PagenotfoundComponent } from './shared/component/pagenotfound/pagenotfound.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: '',
    // canLoad: [auth2Guard],
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [authGuard],
    children: [
      // {
      //   path: 'import-order',
      //   component: ImportOrderComponent,
      //   // canActivate: [AuthGuard],
      //   data: { title: 'Opollo WMS' }
      // },
      
      {
        path: 'access-management-services',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/access-management/access-management.module').then(m => m.AccessManagementModule)
      },
      
      {
        path: 'dashboardnm',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'setting',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'utility',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/utility/utility.module').then(m => m.UtilityModule)
      },
      {
        path: 'account-configuration',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/account-configuration/account-configuration.module').then(m => m.AccountConfigurationModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('./module/orders/orders/orders-routing.module').then(m => m.ordersRoutingModule)
      },
      {
        path: 'master',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/ems-master/ems-master/ems-master.module').then(m => m.EmsMasterModule)
      },
      {
        path: 'revenue-reports',
        loadChildren: () => import('./module/revenue-report/revenue-report-routing.module').then(m => m.RevenueReportRoutingModule)
      },
      {
        path: 'on-roll-salary',
        loadChildren: () => import('./module/on-roll-salary/on-roll-salary-routing.module').then(m => m.OnRollSalaryRoutingModule)
      },
      {
        path: 'volume-data',
        loadChildren: () => import('./module/volume-data-admin/volume-data-admin-routing.module').then(m => m.VolumeDataAdminRoutingModule)
      },
      {
        path: 'invoices',
        loadChildren: () => import('./module/invoices/invoices-routing.module').then(m => m.InvoicesRoutingModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./module/reports/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'dashboard',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/analytics/analytics.module').then(m => m.AnalyticsModule)
      },
      {
        path: 'vendor',
        loadChildren: () => import('./module/vendors/vendors.module').then(m => m.VendorsModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./module/customers/customers.module').then(m => m.customersModule)
      },
      {
        path: 'associate',
        loadChildren: () => import('./module/associates/associates.module').then(m => m.associatesModule)
      },
      {
        path: 'wage',
        loadChildren: () => import('./module/wages/wage.module').then(m => m.wageModule)
      },
      {
        path: 'wage-master',
        loadChildren: () => import('./module/wage-master/master/wage-master.module').then(m => m.wageMasterModule)
      },
    ]
  },
  { path: 'pageNotFound', component: PagenotfoundComponent},
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
